import { render, staticRenderFns } from "./MajorShareholdersHs.vue?vue&type=template&id=5b09abcc&scoped=true"
import script from "./MajorShareholdersHs.vue?vue&type=script&lang=js"
export * from "./MajorShareholdersHs.vue?vue&type=script&lang=js"
import style0 from "./MajorShareholdersHs.vue?vue&type=style&index=0&id=5b09abcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b09abcc",
  null
  
)

export default component.exports